import all from "gsap/all";
import { tns } from "tiny-slider/src/tiny-slider";

export default function Sliders() {
  loadSliders();
  galleryCarousel();
  singleImage();
  productCarousel();
  fourProductCarousel();
}

export function loadSliders() {
  const allSliders = document.querySelectorAll(".carousel");
  if (!allSliders.length) return;
  allSliders.forEach((sliderWrapper) => {
    const sliderDiv = sliderWrapper.querySelector(".slider"); // container with slider
    const controlsContainer = sliderWrapper.querySelector(
      ".customise-controls"
    );
    const checkFrozen = function () {
      if (sliderWrapper.querySelector(".controls").style.display == "none") {
        sliderWrapper.classList.add("frozen");
      } else {
        sliderWrapper.classList.remove("frozen");
      }
    };

    let slider = tns({
      container: sliderDiv,
      autoplay: false,
      nav: false,
      mouseDrag: true,
      autoWidth: true,
      lazyload: false,
      controlsContainer: controlsContainer,
      loop: false,
      onInit: () => checkFrozen(),
    });

    window.addEventListener("resize", (e) => {
      checkFrozen();
    });
  });
}

function galleryCarousel() {
  const allSliders = document.querySelectorAll(".gallery-carousel");

  allSliders.forEach((sliderWrapper) => {
    const slider = sliderWrapper.querySelector(".slider"); // container with slider
    const controlsContainer = sliderWrapper.querySelector(
      ".customise-controls"
    );
    var next = sliderWrapper.querySelector(".next");
    var prev = sliderWrapper.querySelector(".prev");

    tns({
      container: slider,
      center: true,
      autoplay: false,
      nav: false,
      mouseDrag: false,
      autoWidth: true,
      items: 1,
      gutter: 100,
      lazyload: false,
      controlsContainer: controlsContainer,
    });

    setTimeout(function () {
      scaleImage();
    }, 1000);

    next.addEventListener("click", function () {
      setTimeout(function () {
        scaleImage();
      }, 100);
    });

    prev.addEventListener("click", function () {
      setTimeout(function () {
        scaleImage();
      }, 100);
    });
  });
}

function scaleImage() {
  var activeSlides = document.querySelectorAll(
    ".gallery-carousel .tns-slide-active"
  );
  var i;

  for (i = 0; i < activeSlides.length; i++) {
    activeSlides[i].classList.remove("active");

    if (i == 1) {
      activeSlides[1].classList.add("active");
    }
  }
}

function singleImage() {
  const singleSliders = document.querySelectorAll(".single-carousel");
  if (singleSliders) {
    singleSliders.forEach((sliderWrapper) => {
      const slider = sliderWrapper.querySelector(".slider"); // container with slider
      const controlsContainer = sliderWrapper.querySelector(
        ".customise-controls"
      );
      tns({
        container: slider,
        autoplay: false,
        nav: false,
        mouseDrag: false,
        lazyload: true,
        items: 1,
        controlsContainer: controlsContainer,
      });
    });
  }
}

function productCarousel() {
  const navSliders = document.querySelectorAll(".single-carousel-with-nav");
  const navContainer = document.querySelector(".customise-thumbnails");
  if (navSliders && navContainer) {
    navSliders.forEach((sliderWrapper) => {
      const slider = sliderWrapper.querySelector(".slider"); // container with slider
      const controlsContainer = sliderWrapper.querySelector(
        ".customise-controls"
      );

      tns({
        container: slider,
        autoplay: false,
        mouseDrag: false,
        lazyload: false, //slider used in hero carousel shouldn't be lazy, we want those images fast!
        items: 1,
        controlsContainer: controlsContainer,
        navAsThumbnails: true,
        navContainer: navContainer,
        center: true,
      });
    });

    tns({
      loop: true,
      container: navContainer,
      items: 0,
      mouseDrag: false,
      nav: false,
      controls: false,
      gutter: 8,
    });
  }
}

function fourProductCarousel() {
  const fourProductCarousel = document.querySelectorAll(
    ".four-product-carousel"
  );
  if (fourProductCarousel) {
    fourProductCarousel.forEach((sliderWrapper) => {
      const slider = sliderWrapper.querySelector(".slider"); // container with slider
      const controlsContainer = sliderWrapper.querySelector(
        ".customise-controls"
      );
      var slideCount = parseInt(sliderWrapper.getAttribute("data-count"));

      // Design review PASS 1, note 27 ("Mobile carousel layout appears to differ from design") is
      // NOT fixed here. The 393px design (Figma node 5612:15513) shows a peeking two-up: 275px
      // cards, 16px apart, with the next one part-visible. The card is already close - 265px at
      // the stock 32px slide padding - so the missing piece is only the peek.
      // Neither lever worked: `items: 1.13` produced a 215px slide (not the 291px the container
      // arithmetic predicts), and `fixedWidth: 291` left it at 215 as well, so something else is
      // sizing these slides. Both attempts were reverted rather than left in doing nothing.
      // Worth checking whether a second init is also binding to this carousel before trying again.
      tns({
        container: slider,
        autoplay: false,
        mouseDrag: false,
        lazyload: true,
        loop: true,
        controlsContainer: controlsContainer,
        navAsThumbnails: true,
        items: 1,
        navPosition: "bottom",
        responsive: {
          620: {
            items: 1,
          },

          1040: {
            disable: slideCount < 4 ? true : false,
            items: 2,
          },

          1200: {
            // 3-up view: only run as a carousel when there are more than 3 items
            disable: slideCount < 4 ? true : false,
            items: 3,
          },
        },
      });

      if (slideCount < 4) {
        window.addEventListener("resize", function () {
          if (slider.hasAttribute("style") && this.window.innerWidth >= 1040) {
            slider.removeAttribute("style");
          }
        });
      }
    });
  }
}
